import { Link } from "react-router-dom";
import { Accessibility } from "lucide-react";

export default function AccessibilityButton() {
  return (
    <Link
      to="/accessibility-statement"
      aria-label="הצהרת נגישות"
      title="הצהרת נגישות"
      className="fixed bottom-6 left-6 z-40 inline-flex h-14 w-14 items-center justify-center rounded-full border border-primary/30 bg-background/95 text-primary shadow-lg backdrop-blur-md transition-all hover:scale-110 hover:bg-primary hover:text-primary-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      <Accessibility className="h-6 w-6" aria-hidden="true" />
    </Link>
  );
}